"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var GenericWidget_1 = __importDefault(require("../GenericWidget"));

var Cell = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var CellContent = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /** \n   * Toto existuje, kvoli spravnemu pocitaniu sirky flex children\n   * Je potrebne zabezpecit, aby layouty 2:1 a 1:1:1, mali zarovnane posledne stlpce\n   */\n  margin-left: ", "px;\n"], ["\n  /** \n   * Toto existuje, kvoli spravnemu pocitaniu sirky flex children\n   * Je potrebne zabezpecit, aby layouty 2:1 a 1:1:1, mali zarovnane posledne stlpce\n   */\n  margin-left: ", "px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.grid.gutterWidth;
});

function transformCells(cells, layout) {
  if (cells === void 0) {
    cells = [];
  }

  if (layout === void 0) {
    layout = '1:1';
  }

  var numberOfCells = layout.split(':').length;

  if (cells.length > numberOfCells) {
    return cells.slice(0, numberOfCells);
  } else if (cells.length < numberOfCells) {
    return __spreadArrays(cells, new Array(numberOfCells - cells.length).fill(0).map(function () {
      return {
        content: []
      };
    }));
  }

  return cells;
}

exports.transformCells = transformCells;
var Wrapper = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-left: ", "px;\n\n  ", "\n"], ["\n  margin-left: ", "px;\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return -theme.grid.gutterWidth;
}, function (_a) {
  var layout = _a.layout;

  if (layout === '1:1') {
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n        }\n      "], ["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n        }\n      "])), Cell);
  } else if (layout === '1:1:1') {
    return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n        }\n      "], ["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n        }\n      "])), Cell);
  } else if (layout === '1:2') {
    return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n          &:nth-child(1) {\n            flex-grow: 1;\n          }\n          &:nth-child(2) {\n            flex-grow: 2;\n          }\n        }\n      "], ["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n          &:nth-child(1) {\n            flex-grow: 1;\n          }\n          &:nth-child(2) {\n            flex-grow: 2;\n          }\n        }\n      "])), Cell);
  } else if (layout === '2:1') {
    return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n          &:nth-child(1) {\n            flex-grow: 2;\n          }\n          &:nth-child(2) {\n            flex-grow: 1;\n          }\n        }\n      "], ["\n        display: flex;\n        flex-wrap: wrap;\n\n        ", " {\n          min-width: 300px;\n          flex: 1 0 0;\n          &:nth-child(1) {\n            flex-grow: 2;\n          }\n          &:nth-child(2) {\n            flex-grow: 1;\n          }\n        }\n      "])), Cell);
  }
});

var C = function C(_a) {
  var renderLink = _a.renderLink,
      renderEmpty = _a.renderEmpty,
      _b = _a.renderCell,
      renderCell = _b === void 0 ? function (ch, idx, cellContent) {
    return ch;
  } : _b,
      _c = _a.data,
      _d = _c.cells,
      cells = _d === void 0 ? [] : _d,
      layout = _c.layout;
  var localCells = cells;
  var localLayout = layout;

  if (!['1:1', '1:2', '2:1', '1:1:1'].includes(layout)) {
    localLayout = '1:1';
  }

  localCells = transformCells(localCells, localLayout);
  return react_1["default"].createElement(Wrapper, {
    layout: localLayout
  }, localCells.map(function (cell, cellIdx) {
    var children = react_1["default"].createElement(CellContent, null, (cell.content || []).map(function (widget, idx) {
      return react_1["default"].createElement(GenericWidget_1["default"], {
        key: idx,
        widget: widget,
        renderLink: renderLink,
        renderEmpty: renderEmpty
      });
    }));
    return react_1["default"].createElement(Cell, {
      key: cellIdx,
      "data-testid": "Multiblock_Cell_" + cellIdx
    }, renderCell(children, cellIdx, cell.content || []));
  }));
};

exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;